import React from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import { BlazeTableColDef } from './BlazeTable.types';
import ExpandLink from './ExpandLink';

interface BlazeTableCellProps {
  columnDefinition: BlazeTableColDef;
  item: any;
  index: number;
  expandRowHandler?: (id: number) => void;
}

const BlazeTableCell = (props: BlazeTableCellProps) => {
  const { columnDefinition, item, index } = props;

  /**
   * Creates the link on the column to expand/collapse the detail
   */
  const createExpandLink = (value: any, id: number) => (
    <ExpandLink
      value={value}
      id={id}
      onToggleExpandDetail={() => {
        if (props.expandRowHandler) {
          props.expandRowHandler(id);
        }
      }}
    />
  );

  const customCellClass = columnDefinition.cellClass
    ? _.isFunction(columnDefinition.cellClass)
      ? columnDefinition.cellClass(item)
      : columnDefinition.cellClass
    : '';

  return (
    <div
      className={clsx(
        'flex-table-col',
        columnDefinition.width && 'flex-table-col-' + columnDefinition.width,
        customCellClass,
      )}
      title={
        columnDefinition.cellComponent ? '' : item[columnDefinition.accessor] ? item[columnDefinition.accessor] : ''
      }
    >
      {columnDefinition.cellComponent
        ? columnDefinition.cellComponent(item)
        : columnDefinition.isExpandLink
        ? createExpandLink(item[columnDefinition.accessor], item.id)
        : item[columnDefinition.accessor]}
    </div>
  );
};

export default BlazeTableCell;
